export default __webpack_public_path__ + "50e380db78f1d321fe1ce5bacea07644.png";